import { useStableCallback } from "./internal/hooks/useStableCallback.js";
import { toast as toast$1 } from "./toast-D6Z6MOB5.js";
import { useEffect, useId, useRef } from "react";
import { jsx } from "react/jsx-runtime";
import { Toaster } from "sonner";
//#region src/components/Toast/useNotification.tsx
/**
* A persistent, system-driven notification (trial expiry, upgrade prompt, billing alert).
*
* - Stays until the user dismisses it or the component unmounts; `toast()` is for transient
*   feedback after a user action.
* - A visible one updates in place when its string `title` or `description` changes; other
*   options apply the next time it shows.
*/
const useNotification = ({ enabled = true, remindAfter, ...toastOptions }) => {
	const fallbackId = useId();
	const toastId = toastOptions.id ?? fallbackId;
	const isShownRef = useRef(false);
	const reminderRef = useRef(void 0);
	const show = useStableCallback(() => {
		isShownRef.current = true;
		toast$1({
			...toastOptions,
			id: toastId,
			duration: toastOptions.duration ?? Infinity,
			onDismiss: (dismissed) => {
				toastOptions.onDismiss?.(dismissed);
				if (!isShownRef.current) return;
				isShownRef.current = false;
				if (remindAfter !== void 0) reminderRef.current = setTimeout(show, remindAfter);
			}
		});
	});
	useEffect(() => {
		if (!enabled) return;
		const frameId = requestAnimationFrame(show);
		return () => {
			cancelAnimationFrame(frameId);
			clearTimeout(reminderRef.current);
			if (!isShownRef.current) return;
			isShownRef.current = false;
			toast$1.dismiss(toastId);
		};
	}, [
		enabled,
		show,
		toastId
	]);
	const titleText = typeof toastOptions.title === "string" ? toastOptions.title : void 0;
	const descriptionText = typeof toastOptions.description === "string" ? toastOptions.description : void 0;
	useEffect(() => {
		if (isShownRef.current) show();
	}, [
		titleText,
		descriptionText,
		show
	]);
};
//#endregion
//#region src/components/Toast/Toaster.tsx
const DEFAULT_STYLES = { "--width": "512px" };
const stopPropagation = (event) => event.stopPropagation();
const Toaster$1 = ({ gap = 12, visibleToasts = 5, ...props }) => /* @__PURE__ */ jsx("div", {
	onPointerDown: stopPropagation,
	children: /* @__PURE__ */ jsx(Toaster, {
		...props,
		gap,
		visibleToasts,
		className: "tw:pointer-events-auto tw:flex tw:w-full tw:max-w-lg tw:justify-center",
		style: DEFAULT_STYLES
	})
});
//#endregion
export { Toaster$1 as Toaster, useNotification };

//# sourceMappingURL=Toast-BGnUL4jV.js.map